export default __webpack_public_path__ + "static/media/cloudCMA-logo.0c2ab40e.svg";